jQuery('.category').click(function(){
	
	var category = jQuery(this).data('category');
	
	if( category == 'all' ) {
		
		jQuery('.blog-post.hidden').removeClass('hidden');
		
	}
	
	else {
		
		var elem = '.blog-post[data-category="' + category + '"]';
		
		jQuery('.blog-post').addClass('hidden');
		
		jQuery( elem ).removeClass('hidden');
		
	}
	
	jQuery('.category.active').removeClass('active');
	
	jQuery(this).addClass('active');
	
});

jQuery('div.info-block').click(function(){
	
	jQuery(this).toggleClass('active');
	
});